'use strict';

const $WINDOW = Symbol('window');
const API = Symbol('apiService');
const ANALYTICS_SERVICE = Symbol('analyticsService');

class IndexController {
  constructor($window, apiService, analyticsService) {
    'ngInject';

    this[$WINDOW] = $window;
    this[API] = apiService;
    this[ANALYTICS_SERVICE] = analyticsService;

    this.buttonText = 'Try it free';
    this.isfree = false;
    this.user = {
      companyName: '',
      name: '',
      email: '',
      password: '',
    };

    this[ANALYTICS_SERVICE].page();

    angular.element('.help-tooltip').tooltip({ container: 'body' });

    /**
     * Intercept and save UTM params in cookies
     *
     * @since STAFF-4854 params are intercepted also if prefixed with '?'
     *  (it can happen if question mark is doubled: '??')
     *  and also if params are not lowercased
     */
    angular.forEach(
      this[ANALYTICS_SERVICE].getUtmParamsFromQueryString(),
      (value, name) => this[ANALYTICS_SERVICE].createCookie(name, value, 1)
    );
  }

  createUser() {
    this.buttonClicked = true;

    // disable form visually
    this.modifyForm('disable');

    if (this.validateForm()) {
      this.formValid = true;
      this.insertUser();
    } else {
      this.formValid = false;
      // enable form again
      this.modifyForm('enable');

      // focus first empty field
      for (const key in this.errors) {
        if (this.errors.hasOwnProperty(key)) {
          if (this.errors[key]) {
            angular.element(`#${key}`).focus();
            return false;
          }
        }
      }
    }
  }

  validateForm() {
    let isValidationOk = true;

    this.errors = {};
    this.errors.companyName = !this.validateString(this.user.companyName);
    this.errors.name = !this.validateString(this.user.name);
    this.errors.email = !this.validateEmail(this.user.email);
    this.errors.password = !this.validatePassword(this.user.password);

    angular.forEach(this.errors, value => {
      if (value) {
        isValidationOk = false;
      }
    });

    return isValidationOk;
  }

  insertUser() {
    const companyName = this.user.companyName;
    const userName = this.user.name;
    const userEmail = this.user.email;
    const trackingMode = 'interactive';

    let token;
    let userId;
    let companyId;
    const timezone = Intl && Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Fb pixel track lead code
    this[ANALYTICS_SERVICE].facebookPixelCodeTrack('Lead');

    this[API]
      .userCreate(
        userName, userEmail, this.user.password, companyName, timezone, trackingMode
      )
      .then((resp) => {
        token = resp.token;
        userId = resp.userId;
        companyId = resp.companyId;

        return this[ANALYTICS_SERVICE].trackEvent(
          'sign-up-create-user',
          {
            userId,
            userName,
            userEmail,
            companyId,
            companyName,
            timezone,
            trackingMode,
          }
        );
      }).then(() => (
        this[ANALYTICS_SERVICE].trackEvent(
          'sign-up-create-company',
          {
            userId,
            userName,
            userEmail,
            companyId,
            companyName,
            timezone,
            trackingMode,
          }
        )
      )).then(() => {
        this.goToDashboard(token);
      })
      .catch((response) => {
        if (response.data.error === 'loginExists') {
          this.formValid = false;
          angular.element('.user-error-modal').modal();
          this.modifyForm('enable');
        }
      });
  }

  goToDashboard(token) {
    let url = 'https://app.staff.com';

    if (token) {
      url += `?first-login=1&token=${token}`;

      /**
       * Intercept UTM params
       *
       * @since STAFF-4854 params are intercepted also if prefixed with '?'
       *  (it can happen if question mark is doubled: '??')
       *  and also if params are not lowercased
       */
      angular.forEach(
        this[ANALYTICS_SERVICE].getUtmParamsFromCookies(true),
        (value, name) => url += `&${name}=${value}`
      );
    }

    this[$WINDOW].location = url;
  }

  modifyForm(action) {
    if (action === 'disable') {
      this.isValidating = true;
      this.buttonText = 'Creating account ...';
    } else {
      this.isValidating = false;
      this.buttonText = 'Try it free';
    }
  }

  validateEmail(emailString) {
    return /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,20})+$/.test(emailString);
  }

  validateString(checkString) {
    return !(checkString === '' || checkString.replace(/^\s+|\s+$/g, '').length === 0);
  }

  validatePassword(passwordString) {
    return passwordString.length < 6 || /\s/g.test(passwordString) ? !1 : !0;
  }
}

export default IndexController;
